"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require("redux");

var _reactRouterRedux = require("react-router-redux");

var _auth = require("./auth");

var _auth2 = _interopRequireDefault(_auth);

var _app = require("./app");

var _app2 = _interopRequireDefault(_app);

var _lang = require("./lang");

var _lang2 = _interopRequireDefault(_lang);

var _user = require("./user");

var _user2 = _interopRequireDefault(_user);

var _reports = require("./reports");

var _reports2 = _interopRequireDefault(_reports);

var _reportDetail = require("./reportDetail");

var _reportDetail2 = _interopRequireDefault(_reportDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the default root reducer
var rootReducer = (0, _redux.combineReducers)({
    auth: _auth2.default,
    app: _app2.default,
    lang: _lang2.default,
    user: _user2.default,
    reports: _reports2.default,
    reportDetail: _reportDetail2.default,
    routing: _reactRouterRedux.routerReducer
});
exports.default = rootReducer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/rootReducer.ts
 ** module id = 1298
 ** module chunks = 0
 **/